import { Glyph } from "../../types";

const SvgPaperClip: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M7 0c1.713 0 2.912 1.138 2.995 2.812L10 3v8c0 1.207-.892 2-2 2-1.057 0-1.918-.723-1.995-1.838L6 11V5.5a.5.5 0 0 1 .992-.09L7 5.5V11c0 .627.42 1 1 1 .538 0 .939-.322.994-.87L9 11V3c0-1.224-.776-2-2-2-1.168 0-1.929.707-1.995 1.836L5 3v9l.005.183C5.092 13.813 6.338 15 8 15s2.908-1.187 2.995-2.817L11 12V5.5a.5.5 0 0 1 .992-.09L12 5.5V12c0 2.276-1.724 4-4 4-2.207 0-3.895-1.621-3.995-3.795L4 12V3l.005-.188C4.088 1.138 5.288 0 7 0" />
    </svg>
  );
};

export default SvgPaperClip;
